export default "__VITE_ASSET__D4b8FYhr__"